//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import moment from 'moment';
export default {
  name: 'EquipmentControlLogModal',
  data: function data() {
    return {
      title: '操作',
      visible: false,
      model: {},
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        info: {
          rules: [{
            required: true,
            message: '请输入控制参数!'
          }]
        }
      },
      deviceList: {},
      loginUser: '',
      url: {
        add: '/online/equipment/control/log' // edit: '/om/equipment/control/log/edit'

      }
    };
  },
  created: function created() {
    this.loginUser = this.$store.getters.userInfo.id;
  },
  methods: {
    add: function add(deviceList) {
      this.deviceList = deviceList;
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(function () {
        _this.form.setFieldsValue(pick(_this.model, 'info')); //时间格式化


        _this.form.setFieldsValue({
          logDate: _this.model.logDate ? moment(_this.model.logDate) : null
        });
      });
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var httpurl = '';
          var method = '';
          httpurl += _this2.url.add;
          method = 'post';
          var formData = Object.assign(_this2.model, values);
          formData.siteId = _this2.deviceList.siteId;
          formData.assetId = _this2.deviceList.id;
          formData.userId = _this2.loginUser;

          if (_this2.deviceList.factorId != null && _this2.deviceList.coding != null) {
            formData.polId = _this2.deviceList.factorId;
            formData.infoId = _this2.deviceList.coding;
            httpAction(httpurl, formData, method).then(function (res) {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
                that.close();
              } else {
                that.$message.warning(res.message);
              }
            }).finally(function () {
              that.confirmLoading = false;
            });
          } else {
            that.$message.warning('现场端控制编码或设备信息编码为空');
            that.confirmLoading = false;

            _this2.handleCancel();
          }
        }
      });
    },
    handleCancel: function handleCancel() {
      this.close();
    }
  }
};